import React from "react";
import { Instagram, UserRound } from "lucide-react";
import { useApp } from "../context/AppContext";

export function AuthChoiceStep({ service, onInstagram, onGuest, onBack }) {
  const { t } = useApp();
  return (
    <section
      className="mx-auto max-w-xl animate-fade-slide-up"
      data-testid="auth-choice-step"
    >
      <button
        type="button"
        onClick={onBack}
        className="mb-4 inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-primary"
        data-testid="auth-back-button"
      >
        ← {t("back")}
      </button>

      <div className="rounded-3xl border border-border bg-card p-6 sm:p-10 text-center firefly-grain relative overflow-hidden">
        <div className="text-xs uppercase tracking-[0.22em] text-primary">
          {t("field_service")} · {t(`service_${service}`)}
        </div>
        <h2 className="mt-3 font-display text-xl font-semibold sm:text-2xl">
          {t("auth_title")}
        </h2>
        <p className="mt-2 text-sm text-muted-foreground sm:text-base">
          {t("auth_subtitle")}
        </p>

        <div className="mt-8 flex flex-col items-stretch gap-3 sm:mx-auto sm:max-w-md">
          <button
            type="button"
            onClick={onInstagram}
            data-testid="login-instagram-button"
            className="btn-cream group relative flex items-center justify-between rounded-lg px-6 py-4 text-left"
          >
            <span className="flex flex-col">
              <span className="font-display text-base tracking-[0.22em] sm:text-lg">
                {t("login_instagram").toUpperCase()}
              </span>
              <span className="mt-0.5 text-[11px] uppercase tracking-[0.15em] text-[hsl(var(--cream-foreground))]/60">
                {t("login_instagram_sub")}
              </span>
            </span>
            <Instagram className="h-5 w-5 text-[hsl(var(--cream-foreground))] opacity-70 transition-transform group-hover:translate-x-0.5" />
          </button>

          <button
            type="button"
            onClick={onGuest}
            data-testid="guest-button"
            className="btn-cream group relative flex items-center justify-between rounded-lg px-6 py-4 text-left"
          >
            <span className="flex flex-col">
              <span className="font-display text-base tracking-[0.22em] sm:text-lg">
                {t("book_as_guest").toUpperCase()}
              </span>
              <span className="mt-0.5 text-[11px] uppercase tracking-[0.15em] text-[hsl(var(--cream-foreground))]/60">
                {t("book_as_guest_sub")}
              </span>
            </span>
            <UserRound className="h-5 w-5 text-[hsl(var(--cream-foreground))] opacity-70 transition-transform group-hover:translate-x-0.5" />
          </button>
        </div>
      </div>
    </section>
  );
}
